import React from 'react';
import { FaRupeeSign, FaUserTie, FaUtensils, FaHotel, FaSmile, FaUsers } from 'react-icons/fa';
import './NeedGhoomo.css';
const features = [
  { icon: <FaRupeeSign className="text-yellow-500 text-xl" />, text: "All inclusive tours, No hidden costs" },
  { icon: <FaUserTie className="text-yellow-500 text-xl" />, text: "Expert tour manager all throughout the tour" },
  { icon: <FaUtensils className="text-yellow-500 text-xl" />, text: "Yummy meals, all included in the tour price" },
  { icon: <FaHotel className="text-yellow-500 text-xl" />, text: "Comfortable & Hygienic hotels" },
  { icon: <FaSmile className="text-yellow-500 text-xl" />, text: "Music, fun and games everyday" },
  { icon: <FaUsers className="text-yellow-500 text-xl" />, text: "Expert team working to ensure you have the best holiday" },
];

const NeedGhoomo = () => {
  return (
    <div className="why-ghoomo-container">
    <h2 className="why-ghoomo-title" style={{fontSize:"14px"}}>Why Ghoomo World?</h2>
    <div className="why-ghoomo-grid">
      {features.map((feature, index) => (
        <div key={index} className="why-ghoomo-item">
          <div className="why-ghoomo-icon">{feature.icon}</div>
          <p className="why-ghoomo-text">{feature.text}</p>
        </div>
      ))}
    </div>
  </div>
  );
};

export default NeedGhoomo;
